import React from "react";
import { Modal, Form, Tooltip, Button, Space, Popconfirm, Input } from "antd";
import ReactSelect from "react-select";
import FormControl from "@mui/material/FormControl";
import { Scrollbars } from "react-custom-scrollbars";

//React Icons
import { CgCalendarDates } from "react-icons/cg";
import { FaRegClock } from "react-icons/fa";
import { IoAlert } from "react-icons/io5";
import { FaCameraRetro } from "react-icons/fa";
import { FaImage } from "react-icons/fa6";
import { ImLocation2 } from "react-icons/im";
import { TbReport } from "react-icons/tb";
import { FaKeyboard } from "react-icons/fa6";
import { IoPerson } from "react-icons/io5";

const { TextArea } = Input;

const StatusModalPopup = ({
  comments,
  name,
  modalOpen,
  cancel,
  modalRecord,
  alertsAssignedMailsoptions,
  esscalationEmailsoptions,
  handleChangeAletsAssignedEmails,
  handleChangeEsscalationEmail,
  statusOptionSelected,
  handleUpdate,
  handleCommentChange,
  commentText,
  handleCommentClick,
  confirm,
  inProgresConfirm,
  PERSONICON,
  DATEICON,
  CLOCKICON,
  CAMERAICON,
  STATUSICON,
  status,
}) => {
  return (
    <Modal
      title="Alert Status"
      centered
      open={modalOpen}
      onOk={cancel}
      onCancel={cancel}
      style={{ top: 20 }}
      width={600}
    >
      <Form layout="vertical">
        {modalRecord?.alertsAssignedMails?.length > 0 &&
        modalRecord?.esscalationEmails?.length > 0 ? (
          <>
            {/* Assigned To */}
            <Form.Item label="Assigned To">
              <div style={{ display: "flex", alignItems: "center" }}>
                <IoPerson
                  className="text-lg text-teal-700"
                  style={{ height: "5vh", fontSize: "5vh" }}
                />
                <Input
                  value={modalRecord?.alertsAssignedMails}
                  disabled
                  style={{ width: "100%" }}
                />
              </div>
            </Form.Item>

            {/* Escalation Emails */}
            <Form.Item label="Escalation Emails">
              <div style={{ display: "flex", alignItems: "center" }}>
                <IoPerson
                  className="text-lg text-teal-700"
                  style={{ height: "5vh", fontSize: "5vh" }}
                />
                <Input
                  value={modalRecord?.esscalationEmails}
                  disabled
                  style={{ width: "100%" }}
                />
              </div>
            </Form.Item>
          </>
        ) : (
          <>
            {/* Select Assigned To */}
            <Form.Item label="Select Assigned To">
              <div style={{ display: "flex", alignItems: "center" }}>
                <IoPerson
                  className="text-lg text-teal-700"
                  style={{ height: "5vh", fontSize: "5vh" }}
                />
                <FormControl style={{ width: "100%" }}>
                  <ReactSelect
                    options={alertsAssignedMailsoptions}
                    isMulti
                    closeMenuOnSelect
                    onChange={handleChangeAletsAssignedEmails}
                    value={statusOptionSelected}
                    placeholder="Select Assigned To"
                  />
                </FormControl>
              </div>
            </Form.Item>

            {/* Select Escalation Emails */}
            <Form.Item label="Select Escalation Emails">
              <div style={{ display: "flex", alignItems: "center" }}>
                <IoPerson
                  className="text-lg text-teal-700"
                  style={{ height: "5vh", fontSize: "5vh" }}
                />
                <FormControl style={{ width: "100%" }}>
                  <ReactSelect
                    options={esscalationEmailsoptions}
                    isMulti
                    closeMenuOnSelect
                    onChange={handleChangeEsscalationEmail}
                    value={statusOptionSelected}
                    placeholder="Select Emails"
                  />
                </FormControl>
              </div>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                block
                style={{ backgroundColor: "#1890ff", borderColor: "#1890ff" }} // Blue button
                onClick={() => handleUpdate(modalRecord?._id)}
              >
                Update
              </Button>
            </Form.Item>
          </>
        )}

        {/* Date & Time */}
        <Form.Item label="Date & Time">
          <div style={{ display: "flex", gap: "2vh" }}>
            <CgCalendarDates
              className="text-lg text-teal-700"
              style={{ height: "5vh", fontSize: "5vh" }}
            />
            <Input
              type="date"
              value={modalRecord?.date}
              disabled
              style={{ width: "50%" }}
            />
            <FaRegClock
              className="text-xl text-teal-700"
              style={{ height: "5vh", fontSize: "5vh" }}
            />
            <Input
              type="time"
              value={modalRecord?.time}
              disabled
              style={{ width: "50%" }}
            />
          </div>
        </Form.Item>

        {/* Camera */}
        <Form.Item label="Camera">
          <div style={{ display: "flex", alignItems: "center" }}>
            <FaCameraRetro
              className="text-xl text-teal-700"
              style={{ height: "5vh", fontSize: "5vh" }}
            />
            {/* <img src={CAMERAICON} alt="Camera Icon" style={{ width: "5vh" }} /> */}
            <Input
              value={modalRecord?.camera}
              disabled
              style={{ width: "100%", marginLeft: "1vh" }}
            />
          </div>
        </Form.Item>

        {/* Comments Section */}
        <Form.Item label="Comments">
          <div style={{ display: "flex", gap: "1vh", alignItems: "center" }}>
            <FaKeyboard
              className="text-xl text-teal-700"
              style={{ height: "5vh", fontSize: "7vh" }}
            />
            <TextArea
              rows={4}
              value={commentText}
              onChange={handleCommentChange}
              disabled={["Close", "Closed"].includes(modalRecord?.status)}
              placeholder="Enter Your Comments"
            />
            <Button
              type="primary"
              onClick={() => handleCommentClick(modalRecord)}
              className="bg-teal-700 hover:bg-teal-600"
              disabled={["Close", "Closed"].includes(modalRecord?.status)}
            >
              Comment
            </Button>
          </div>
        </Form.Item>

        {/* Status Section */}
        <Form.Item label="Status">
          <div style={{ display: "flex", alignItems: "center", gap: "1vh" }}>
            <TbReport
              className="text-xl text-teal-700"
              style={{ height: "5vh", fontSize: "5vh" }}
            />
            <Input
              value={
                modalRecord?.status === "Open" || !modalRecord?.status
                  ? "Open"
                  : modalRecord?.status
              }
              disabled
              style={{ width: "50%" }}
            />
            <Space>
              {["Open", "InProgress"].includes(modalRecord?.status) && (
                <>
                  <Popconfirm
                    title="Close the status"
                    onConfirm={() => confirm(modalRecord)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "#ff4d4f",
                        borderColor: "#ff4d4f",
                      }} // Red button for close
                    >
                      Close
                    </Button>
                  </Popconfirm>
                  {modalRecord?.status === "Open" && (
                    <Popconfirm
                      title="Move to In Progress"
                      onConfirm={() => inProgresConfirm(modalRecord)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: "#e3b505",
                          borderColor: "#e3b505",
                        }} // Yellow button for in progress
                      >
                        In Progress
                      </Button>
                    </Popconfirm>
                  )}
                </>
              )}
            </Space>
          </div>
        </Form.Item>

        {/* Comments History */}
        {comments?.length > 0 && (
          <Form.Item label="Comment History">
            <Scrollbars style={{ height: 100 }}>
              <ul>
                {comments.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      padding: "1vh",
                      marginBottom: "1vh",
                      border: "1px solid skyblue",
                      borderRadius: "3px",
                    }}
                  >
                    <div>{item.comment}</div>
                    <small style={{ color: "slategrey" }}>
                      {new Date(item.date).toDateString()} {item.time} by{" "}
                      {item.name}
                    </small>
                  </li>
                ))}
              </ul>
            </Scrollbars>
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default StatusModalPopup;
